import styles from "./select-panel.module.scss";

/** Classe do módulo que esconde a barra nativa da lista; a tela e os specs conferem o wrapper por ela. */
export const SELECT_PANEL_ITEMS_CLASS = styles.items as string;
